import { useQuery } from "react-query";
import { getActiveOfficeDepartment } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetActiveOfficeDepartment = () => {
  return useQuery("GetActiveOfficeDepartment", getActiveOfficeDepartment, {
    refetchOnWindowFocus: false,
  });
};
